<template>
  <v-toolbar app class="pr-0">
    <v-toolbar-items v-if="text">
      <v-btn flat v-for="route in routes"
        v-if="route.toolbarName"
        :key="route.toolbarName"
        :to="route.path"
        :href="route.link"
      >
        {{ route.toolbarName }}
      </v-btn>
    </v-toolbar-items>

    <v-toolbar-items v-else>
      <v-btn icon v-for="route in routes"
        v-if="route.toolbarName"
        :key="route.toolbarName"
        :to="route.path"
        :href="route.link"
      >
        <v-icon>{{ route.icon }}</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-spacer />

    <v-toolbar-side-icon>
      <v-icon medium @click="$emit('toggle')">
        mdi-theme-light-dark
      </v-icon>
    </v-toolbar-side-icon>
  </v-toolbar>
</template>

<script>
export default {
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    text() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
};
</script>
